import React from "react";
import {
  SectionCard,
  getFieldStyle,
  getLabelStyle,
} from "./patientChartShared";

export default function EncounterSummarySection({
  selectedEncounterId,
  encounterForm = {},
  setEncounterField,
  expandedSections,
  toggleSection,
  sectionRef,
  activeSection,
  readOnlyMode = false,
  errorCount = 0,
}) {
  return (
    <SectionCard
      title="Encounter Summary"
      sectionKey="summary"
      expandedSections={expandedSections}
      toggleSection={toggleSection}
      sectionRef={sectionRef}
      activeSection={activeSection}
      errorCount={errorCount}
    >
      {!selectedEncounterId ? (
        <div style={{ color: "#64748b" }}>
          No active encounter selected. Click <strong>Create Encounter</strong> to start charting.
        </div>
      ) : (
        <div style={{ display: "grid", gap: 8 }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                window.innerWidth <= 768
                  ? "1fr"
                  : "1fr 1fr .9fr .95fr .95fr",
              gap: 8,
              alignItems: "end",
            }}
          >
            <label style={getLabelStyle(encounterForm.arrivalDate, true)}>
              Arrival Date
              <input
                type="date"
                style={getFieldStyle(encounterForm.arrivalDate, true)}
                value={encounterForm.arrivalDate || ""}
                onChange={(e) => setEncounterField("arrivalDate", e.target.value)}
                disabled={readOnlyMode}
              />
            </label>

            <label style={getLabelStyle(encounterForm.arrivalTime, true)}>
              Arrival Time
              <input
                style={getFieldStyle(encounterForm.arrivalTime, true)}
                value={encounterForm.arrivalTime || ""}
                onChange={(e) => setEncounterField("arrivalTime", e.target.value)}
                disabled={readOnlyMode}
              />
            </label>

            <label style={getLabelStyle(encounterForm.bed, false)}>
              Bed
              <input
                style={getFieldStyle(encounterForm.bed, false)}
                value={encounterForm.bed || ""}
                onChange={(e) => setEncounterField("bed", e.target.value)}
                disabled={readOnlyMode}
              />
            </label>

            <label style={getLabelStyle(encounterForm.seenAt, true)}>
              Seen At
              <select
                style={getFieldStyle(encounterForm.seenAt, true)}
                value={encounterForm.seenAt || ""}
                onChange={(e) => setEncounterField("seenAt", e.target.value)}
                disabled={readOnlyMode}
              >
                <option value="">Select</option>
                <option value="HQ">HQ</option>
                <option value="Course">Course</option>
                <option value="Tent">Tent</option>
                <option value="Other">Other</option>
              </select>
            </label>

            <label style={getLabelStyle(encounterForm.source, true)}>
              Source
              <select
                style={getFieldStyle(encounterForm.source, true)}
                value={encounterForm.source || ""}
                onChange={(e) => setEncounterField("source", e.target.value)}
                disabled={readOnlyMode}
              >
                <option value="">Select</option>
                <option value="Cart">Cart</option>
                <option value="Walk-up">Walk-up</option>
                <option value="House-Call">House-Call</option>
              </select>
            </label>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                window.innerWidth <= 768
                  ? "1fr"
                  : "minmax(0, 1.6fr) minmax(220px, 1fr) minmax(220px, 1fr)",
              gap: 8,
              alignItems: "end",
            }}
          >
            <label style={getLabelStyle(encounterForm.chiefComplaint, true)}>
              Chief Complaint
              <input
                style={getFieldStyle(encounterForm.chiefComplaint, true)}
                value={encounterForm.chiefComplaint || ""}
                onChange={(e) =>
                  setEncounterField("chiefComplaint", e.target.value)
                }
                disabled={readOnlyMode}
              />
            </label>

            <label style={getLabelStyle(encounterForm.providerName, true)}>
              Provider
              <input
                list="provider-options"
                style={getFieldStyle(encounterForm.providerName, true)}
                placeholder="Start typing provider name..."
                value={encounterForm.providerName || ""}
                onChange={(e) =>
                  setEncounterField("providerName", e.target.value)
                }
                disabled={readOnlyMode}
              />
            </label>

            <label style={getLabelStyle(encounterForm.reportCompletedBy, true)}>
              Report Completed By
              <input
                list="report-completed-options"
                style={getFieldStyle(encounterForm.reportCompletedBy, true)}
                placeholder="Start typing employee name..."
                value={encounterForm.reportCompletedBy || ""}
                onChange={(e) =>
                  setEncounterField("reportCompletedBy", e.target.value)
                }
                disabled={readOnlyMode}
              />
            </label>
          </div>
        </div>
      )}
    </SectionCard>
  );
}